import { render, staticRenderFns } from "./klockan.vue?vue&type=template&id=74de058e&scoped=true"
import script from "./klockan.vue?vue&type=script&lang=js"
export * from "./klockan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de058e",
  null
  
)

export default component.exports